import { Injectable } from '@angular/core';
import { setupConfig } from 'ionic-angular/config/config';

class Setup{
    ID: string;
    Code: string;

    constructor(id: string, code: string){
        this.ID = id;
        this.Code = code;
    }
}

@Injectable()
export class Setups{
    public ShowCustCrdLmt = new Setup("1", "show_cust_crd_lmt");
    public ShowCustOutBal = new Setup("2", "show_cust_out_bal");
    public ShowCustSOBlkCode = new Setup("3", "show_cust_so_blk_code");
    public ShowCustTaxID = new Setup("4", "show_cust_tax_id");
    public ShowPartialDelivery = new Setup("5", "show_partial_dlvy_flag");
    public ShowPaymentTerm = new Setup("6", "show_payment_term");
    public AllowEditPaymentDate = new Setup("7", "allow_edit_payment_date");
    public AllowEditPaymentTerm = new Setup("8","allow_edit_payment_term");
    public AllowEditPartialDelivery = new Setup("12", "allow_edit_partial_dlvy_checkbox");
    public AllowEditConditionGroup = new Setup("13", "allow_edit_condition_group");
    public AllowUrgentOrder = new Setup("14", "allow_urgent_order");
    public ShowDeliveryDate = new Setup("15", "show_delivery_date");
    public AllowEditDeliveryDate = new Setup("16", "allow_edit_delivery_date");
    public AllowEditProductDescription = new Setup("17", "allow_edit_product_description");
    public AllowLogoutLoginSummaryOrder = new Setup("18", "allow_logout_login_summary_order");
    public AllowQuotationOrder = new Setup("19", "allow_create_quotation");
    public ShowAuditLog = new Setup("20", "show_audit_log");
    public HideInStock = new Setup("21", "hide_in_stock");
    public AllowEditSloc = new Setup("22", "allow_edit_sloc");
    public AllowEditPOConsignment = new Setup("23","allow_edit_PO_consignment");
    public ShowGovHosp = new Setup("24","show_gov_hosp");
    public ShowAllHosp = new Setup("25","show_all_hosp");
    public MandatoryPO = new Setup("27", "mandatory_po");
    public MandatoryAttachment = new Setup("28", "mandatory_attachment");
    // STRY0017814-[TH] Print invoice date- 20-09-2022
    public PrintInvoiceDate = new Setup("29", "print_invoice_date");
    //--STRY0017814-[TH]
    public AllowContractNo = new Setup("31", "allow_contract_no");
    // - STRY0017241 - Add shipping point as additional field - EPC
    public AllowEditShippingPoint = new Setup("32", "allow_edit_shipping_point");
     // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
    public HideRemarks  = new Setup("33", "hide_remarks");
    public HideShippingInstructions = new Setup("34", "hide_shipping_instruction");
    public DisablePONo = new Setup("35", "not_allow_to edit_PO");
    public ShowBaseUOM = new Setup("39", "show_base_uom");
    public ShowPayerDetails = new Setup("40", "show_payer_details");
    public ShowShiptoDetails = new Setup("41", "show_shipto_details");
    public AllowEditRDD = new Setup("45", "allow_edit_rdd");
    public AllowAdhocCustomerInsertion = new Setup("38", "allow_adhoc_customer_insertion");
    public AllowBom = new Setup("10032", "allow_bom");
    public AllowDivisionFilter = new Setup("44", "allow_division_filter");
    public AllowSurchargeOnMOV = new Setup("43", "allow_surcharge_on_mov");
};


// WEBPACK FOOTER //
// ./src/services/setup.ts